import useTranslation from '@app/hooks/use-translation';
import { useGetAppellationsListBulkQuery } from '@app/store/api/qm-module/qm-appeal/qm-appeal.api';
import { CircleButton, PageHeader, Paginator } from '@ui';
import React, { useState } from 'react';

import AnalyticsStatus from '@app/components/ui/analytics-status/analytics-status';

import { PaginationResponse } from '@app/components/ui/paginator/paginator';

import Table from '@app/components/table';

import { TableTitle } from '@app/components/table/table.type';

// import { useGetUserInfoQuery } from '@app/store/api/get-user-info.api';

import { qmAppellationsBulkRequestType } from '@app/interfaces/qm-module/qm-appellations/qm-appellations.type';

import QmAppealFilter from './qm-appeal-filter';
import { AppealFilterType } from './blocks/appeal-filter/types';

const QmAppealPage = () => {
  const { t } = useTranslation('pages.qmAppeal');
  const [filter, setFilter] = useState<AppealFilterType>({ filter: [] });
  // const { data: userInfo } = useGetUserInfoQuery();
  const [paginationData, setPaginationData] = useState<PaginationResponse>({
    offset: 0,
    limit: 10,
  });
  const [appealSort, changeAppealSort] = useState<{ sortDesc: boolean; sortBy: string }>();

  const { data: appellationsList } = useGetAppellationsListBulkQuery({
    filter: filter.filter,
    ...paginationData,
    ...(appealSort as Pick<qmAppellationsBulkRequestType, 'sortDesc' | 'sortBy'>),
  } as qmAppellationsBulkRequestType);
  const tableColumns: TableTitle[] = [
    { index: 'dt_create', title: 'Дата создания', filter: true },
    { index: 'dt_sent', title: 'Дата подачи', filter: true },
    { index: 'operatorName', title: 'Инициатор апелляции' },
    { index: 'mfsName', title: 'Название МФ' },
    { index: 'status', title: 'Статус апелляции' },
    { index: 'resolution', title: 'Резолюция' },
    { index: 'inspectName', title: 'Проверяющий' },
    { index: 'dt_processing', title: 'Дата обработки', filter: true },
    { index: 'actions', title: 'Действия', size: 90 },
  ];

  const tableData = appellationsList?.appellations?.map((appeal) => ({
    dt_create: appeal.dt_create,
    dt_sent: appeal.dt_sent,
    operatorName: appeal.operator.name,
    mfsName: appeal.mfs.name,
    status: (
      <div className="w-fit ">
        <AnalyticsStatus className="h-[20px]" qmMode status={appeal.status} />
      </div>
    ),
    resolution: appeal.resolution ? t(`filter.resolutions.${appeal.resolution}`) : '',
    inspectName: appeal.inspect.name,
    dt_processing: appeal.dt_processing,
    actions: (
      <div className="absolute z-[100]">
        <CircleButton
          icon="Oscilogram"
          size={22}
          hintTitle={t('hints.monitoring_view')}
          // disable={
          // //   userInfo?.qm_role === 'supervisor'
          // //     ? appeal.status !== 'CREATED'
          // //     : userInfo?.qm_role === 'manager'
          // //     ? appeal.status === 'CREATED'
          // //     : true
          // // }
          onClick={() =>
            window.open(`${window.location.href}/${appeal.mfs.id}/${appeal.record_id}`, '_blank')
          }
          // link={`${appeal.mfs.id}/${appeal.record_id}`}
        />
        {/* `${appeal.mfs.id}/${appeal.record_id}` */}
      </div>
    ),
  }));
  return (
    <>
      <PageHeader label={t('page_header')} />
      <QmAppealFilter filter={filter} setFilter={setFilter} />
      <div className="flex flex-col gap-[20px]">
        <Table
          default_width={7}
          truncate={false}
          onFilter={changeAppealSort}
          hideDragMode
          columns={tableColumns}
          dataSource={tableData || []}
        />
        <Paginator
          page={paginationData.offset + 1}
          limit={paginationData.limit}
          count={appellationsList?.total || 0}
          onChange={setPaginationData}
        />
      </div>
    </>
  );
};

export default QmAppealPage;
